// Footer — tagline + 2 link columns (Studio + Resources). No company framing,
// no pricing/blog/about stubs — this is a teaching tool, not a product.

import { Logo } from "@/components/ui";
import { appHref } from "@/components/home/links";

const COLS: Array<{
  h: string;
  l: Array<{ label: string; href: string }>;
}> = [
  {
    h: "Studio",
    l: [
      { label: "Open Studio", href: "/dashboard" },
      { label: "Templates", href: "/templates" },
    ],
  },
  {
    h: "Resources",
    l: [
      { label: "Docs", href: "#concept" },
      { label: "agents.md", href: "/agents.md" },
      { label: "Examples", href: "/templates" },
      { label: "GitHub", href: "https://github.com" },
    ],
  },
];

export default function HomeFooter() {
  return (
    <footer className="mx-auto mt-6 max-w-[1320px] border-t border-border px-7 pt-10 pb-6">
      <div className="grid grid-cols-[1.6fr_repeat(2,1fr)] gap-9">
        <div>
          <div className="mb-2.5 flex items-center gap-[9px]">
            <Logo size={20} />
            <span className="text-[13px] font-semibold text-ink">
              Harness Builder
            </span>
          </div>
          <div className="max-w-[320px] text-[12px] leading-[1.5] text-muted">
            A visual designer for AI harnesses. Built to help teams think in
            systems instead of single prompts &mdash; then port the design to
            whichever agent platform they already use.
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.h}>
            <div className="mb-2.5 font-mono text-[10px] font-semibold uppercase tracking-[0.10em] text-muted">
              {c.h}
            </div>
            <ul className="m-0 flex list-none flex-col gap-[7px] p-0">
              {c.l.map((x) => (
                <li key={x.label}>
                  <a
                    href={appHref(x.href)}
                    className="text-[12.5px] text-ink-2 no-underline hover:text-ink"
                  >
                    {x.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-8 flex justify-between border-t border-border pt-[18px] font-mono text-[10.5px] tracking-[0.04em] text-muted">
        <span>© 2026 Harness Builder · v0.4 concept</span>
        <span>// shaped like the system you&rsquo;re building</span>
      </div>
    </footer>
  );
}
